import vue from "vue";

// 这里就是我们刚刚创建的那个静态组件
import messageComponent from "./popups.vue";

// 返回一个 扩展实例构造器
const MessageConstructor = vue.extend(messageComponent);
let messageDom;
// 定义弹出组件的函数 接收2个参数, 要显示的文本 和 显示时间
function showMessage(title) {
  // 实例化一个 message.vue
  messageDom = new MessageConstructor({
    el: document.createElement("div"),
    data() {
      return {
        title: title || "请滑动下方滑块以完成验证",
        show: true
      };
    }
  });
  document.body.appendChild(messageDom.$el);
  return messageDom;
}
showMessage.closeMsg = function() {
  messageDom.closeMsg();
};
// 注册为全局组件的函数
function registryPopup() {
  // 将组件注册到 vue 的 原型链里去,
  // 这样就可以在所有 vue 的实例里面使用 this.$toast()
  vue.prototype.$popups = showMessage;
}

export default registryPopup;



// WEBPACK FOOTER //
// ./src/components/popup/index.js